import { takeEvery, call, put, select } from "redux-saga/effects";
import { SubmissionError } from "redux-form";
import transformToRide from '../../../utils/transformToRide';
import { isRequired, validateValues, atLeast } from "../../../utils/validation";
import { submitFormRoutine } from "../../actions/formRoutines/reservation";
import RideService from "../../../services/ride";
import { reset } from "redux-form";

function* validate({ payload: { values } }) {
  const errors = validateValues(values, {
    routePoints: [
      isRequired, atLeast(2),
    ],
    dateTime: [ isRequired ],
    paymentType: [ isRequired ],
    vehicleType: [ isRequired ],
  });

  if (errors) {
    yield put(submitFormRoutine.failure(new SubmissionError(errors)));
  } else {
    yield call(sendFormDataToServer, values);
  }

  yield put(submitFormRoutine.fulfill());
}

function* sendFormDataToServer(values) {
  try {
    const account = yield select();

    yield put(submitFormRoutine.request());

    debugger;
    const response = yield call(RideService.book, transformToRide(values,  account.authorization.client.account));
    if (response) {
      yield put(submitFormRoutine.success(response.id));
    }
  } catch (error) {
    yield put(submitFormRoutine.failure(error));
  }
}

function* clearForm() {
  yield put(reset('reservation'));
}

export default [
  takeEvery(submitFormRoutine.TRIGGER, validate),
  takeEvery(submitFormRoutine.SUCCESS, clearForm),
];
